/* eslint-disable react/no-array-index-key */
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl, { FormControlProps } from "@material-ui/core/FormControl";
import MUISelect, { SelectProps as MUISelectProps } from "@material-ui/core/Select";
import React, { FC } from "react";
import { styled } from "@material-ui/styles";

export type SelectOptionType = {
  label: string;
  value: string;
  key?: any;
};

type SelectProps = {
  options: SelectOptionType[];
};

const StyledFormControl = styled(FormControl)<FormControlProps>(() => ({
  "& .MuiInputBase-root": {
    height: 48,
  },
  "& label": {
    transform: "translate(14px, 17px) scale(1)",
  },
  "& label.Mui-focused": {
    color: "#034980",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "1px solid #9E9E9E",
      borderRadius: 4,
    },
    "&.Mui-focused fieldset": {
      border: "1px solid #034980",
    },
  },
}));

const Select: FC<MUISelectProps & FormControlProps & SelectProps> = ({
  variant,
  className,
  label,
  value,
  onChange,
  name,
  options,
  ...rest
}) => {
  return (
    <StyledFormControl variant={variant ?? "outlined"} className={className} fullWidth>
      <InputLabel>{label}</InputLabel>
      <MUISelect
        value={value}
        onChange={onChange}
        name={name}
        label={label}
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          getContentAnchorEl: null,
        }}
        {...rest}
      >
        {!value ? <MenuItem>{label}</MenuItem> : null}
        {options.map((option: SelectOptionType, index: number) => (
          <MenuItem key={option?.key ? option.key : `${option.label}-${index}`} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </MUISelect>
    </StyledFormControl>
  );
};

export default Select;
